const mediaItems = [
  {
    id: 1,
    title: '星际迷航：新纪元',
    tag: '4K 预告',
    desc: '跨越星海的终极冒险，人类命运在此一战',
    duration: '02:35',
    views: '128.6w',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20battle%20cinematic%20scene%20with%20starships%20and%20nebulae%2C%20dramatic%20lighting%2C%20dark%20deep%20space%20background%2C%20blockbuster%20movie%20visual%2C%20intense%20action%20moment%2C%20film%20poster%20quality&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '暗影追踪',
    tag: '正式预告',
    desc: '隐藏于黑暗中的真相，一场生死追踪即将展开',
    duration: '03:12',
    views: '96.3w',
    img: 'https://readdy.ai/api/search-image?query=Dark%20thriller%20cinematic%20scene%20with%20shadowy%20figure%20in%20urban%20night%2C%20rain%20and%20neon%20reflections%2C%20intense%20mood%2C%20film%20noir%20style%2C%20dramatic%20contrast%2C%20suspenseful%20atmosphere&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '笑傲江湖2026',
    tag: '爆笑特辑',
    desc: '年度最搞笑喜剧，笑到停不下来',
    duration: '01:48',
    views: '85.7w',
    img: 'https://readdy.ai/api/search-image?query=Bright%20comedic%20cinematic%20scene%20with%20colorful%20festive%20elements%20on%20dark%20background%2C%20warm%20joyful%20lighting%2C%20fun%20dynamic%20composition%2C%20movie%20comedy%20genre%20visual%2C%20energetic%20atmosphere&width=640&height=360&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '迷雾森林',
    tag: '悬疑预告',
    desc: '踏入迷雾笼罩的森林，真相远比想象更加恐怖',
    duration: '02:18',
    views: '73.5w',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20foggy%20forest%20cinematic%20scene%20with%20eerie%20atmosphere%2C%20dark%20trees%20and%20soft%20light%20beams%2C%20thriller%20movie%20visual%2C%20suspenseful%20mood%2C%20atmospheric%20horror%20aesthetic%2C%20film%20quality&width=640&height=360&seq=media-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
            精彩预告
          </h2>
          <p className="text-sm text-foreground-400 max-w-[500px] mx-auto">
            最新最热的电影预告片与精彩片段，先睹为快
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-200/80 via-transparent to-transparent"></div>

                <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded-md bg-background-50/80 backdrop-blur-sm text-xs text-foreground-600 font-medium">
                  {item.tag}
                </span>

                <span className="absolute bottom-2.5 right-2.5 px-2 py-0.5 rounded-md bg-background-50/70 backdrop-blur-sm text-xs text-foreground-500 font-medium">
                  {item.duration}
                </span>

                <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500/85 text-background-50 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-play-fill text-lg ml-0.5"></i>
                </span>
              </div>

              <div className="p-3.5 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-1">
                  {item.desc}
                </p>
                <div className="flex items-center gap-3 mt-2.5">
                  <span className="flex items-center gap-1 text-xs text-foreground-300">
                    <i className="ri-eye-line text-xs"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}